module.exports = __webpack_public_path__ + "img/conferencias.9320cf0b.png";